import {DeviceViewModel} from "../../core/models/device.view-model";
import {autorun, computed, makeObservable} from "mobx";
import {BaseConfig} from "../config/base-config";
import {TermsUtils} from "../utils/terms-utils";
import {AppModuleState} from "../../core/app/models/app-module.state";
import {AppStore} from "../../core/app/app-store";
import {NavigationManager} from "../../core/managers/navigation-manager";
import {BaseLinkModel} from "./link/base-link-model";
import {LoggerUtils} from "../utils/logger/logger-utils";
import {BootstrapSettings} from "../../core/bootstrap/models/bootstrap-settings";
import {BaseMobxState} from "../mobx/base-mobx-state";
import {contractsUtils} from "../utils/contracts-utils";
import {SiteConfig} from "../../core/bootstrap/models/site-config";
import {AppSettings} from "../../core/app/models/app-settings";
import {DatetimeUtils} from "../utils/datetime-utils";
import {LanguageViewModel} from "../../domain/locale/models/language/language.view-model";
import {makeObservableClass} from "../decorators/observable";
import {action} from "mobx"

@makeObservableClass
export class BaseModuleState extends BaseMobxState {
  config: BaseConfig;
  NavigationManager: NavigationManager;
  appStore: AppStore;
  logger: LoggerUtils;
  datetimeUtils: DatetimeUtils;
  device: DeviceViewModel;
  termsUtils: TermsUtils;
  autoruns: Array<Function>;
  betsImpressionsBookmakersIds: Array<Number>;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, BaseConfig];

  constructor(navigationManager: NavigationManager, appStore: AppStore, logger: LoggerUtils, datetimeUtils: DatetimeUtils, device: DeviceViewModel, termsUtils: TermsUtils, config: BaseConfig,) {
    super(config);

    makeObservable(this);

    contractsUtils.requiredType(navigationManager, NavigationManager);
    contractsUtils.requiredType(appStore, AppStore);
    contractsUtils.requiredType(logger, LoggerUtils);
    contractsUtils.requiredType(datetimeUtils, DatetimeUtils);
    contractsUtils.requiredType(device, DeviceViewModel);
    contractsUtils.requiredType(termsUtils, TermsUtils);
    contractsUtils.requiredType(config, BaseConfig);

    this.config = config;
    this.navigationManager = navigationManager;
    this.appStore = appStore;
    this.logger = logger;
    this.datetimeUtils = datetimeUtils;
    this.device = device;
    this.termsUtils = termsUtils;
    this.autoruns = [];
    this.betsImpressionsBookmakersIds = new Map();

    this.onVMCreated();
    this._handleLanguageChange();
  }

  onVMCreated() {
    this.dataSource = null;
    this.appStore.registerCallbackToLanguageChange(() => this._handleLanguageChange())
  }

  @action _handleLanguageChange() {
    this.terms = this.termsUtils.populateI18n(this.config.terms, this.appState.terms);
  }

  get appState(): AppModuleState {
    return this.appStore.state;
  }

  get shouldRenderMinuteMediaPlayer(): Boolean {
    return this.appState.minuteMediaPlayerModel?.shouldRender;
  }

  get appSettings(): AppSettings {
    return this.appState.settings;
  }

  get siteConfig(): SiteConfig {
    return this.appSettings.config;
  }

  @computed get currentLinkModel(): BaseLinkModel {
    return this.navigationManager.currentLinkModel;
  }

  get settings(): BootstrapSettings {
    return this.appState.settings.bootstrapSettings;
  }

  @computed get language(): LanguageViewModel {
    return this.appStore.state.language;
  }

  registerAutorun(func: Function) {
    this.autoruns.push(autorun(func));
  }

  initialState() {
    this.dataSource = null;
    this.terms = this.termsUtils.populateI18n(this.config.terms, this.appState.terms);
  }

  onUnload() {
    super.onUnload();

    this.betsImpressionsBookmakersIds = new Map();
  }
}
